export default {
  type: '',
  partner: {},
  // Credentials
  email: 'test@test.test',
  password: '',
  confirmPassword: '',
  // Profile
  firstName: '',
  lastName: '',
  phone: '',
  birthdate: '',
  gender: 'MALE',
  // Address
  line1: '',
  line2: '',
  city: '',
  state: '',
  zip: ''
}



// WEBPACK FOOTER //
// ./src/store/modules/registration/state.js